<h1 mat-dialog-title><i class="fad fa-pencil"></i>&nbsp;&nbsp; Deseja entrar como qual contabilidade?</h1>
<div mat-dialog-content class="border-top border-bottom">
  <form>

    <div class="mb-4 mt-3">
      <info description="Busque a contabilidade que deseja acessar."></info>
    </div>

    <app-complex-search-input [hackings]="hackings()" [defaultRule]="defaultRule" (filterApplied)="apply($event)"></app-complex-search-input>
    <mat-chip-list #chipList>
      <mat-chip *ngFor="let filter of filters" [selectable]="true" [removable]="true"
        (removed)="removeFilter(filter)">
        {{ filter.description }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>

    <table mat-table matSort [dataSource]="dataSource" class="table-hover mat-elevation-z0 w-100" *ngIf="dataSource.length">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
          <strong>Nome</strong>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="cnpj">
        <th mat-header-cell *matHeaderCellDef> CPF/CNPJ </th>
        <td mat-cell *matCellDef="let element"> {{ element.cnpj }} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="cursor-pointer w-100" [ngClass]="{'signin-as-row-selected': currentAccounting.id === row.id}" *matRowDef="let row; columns: displayedColumns;" (click)="select(row)">
      </tr>
    </table>
    <paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.pageSize" [pageSizeOptions]="[5, 10, 20]" (page)="onPageChange($event)" *ngIf="dataSource.length">
    </paginator>

  </form>
</div>
<div mat-dialog-actions class="text-center">
    <div class="container-fluid px-0 py-3 justify-content-between">
      <button class="btn btn-light text-danger mx-2" mat-dialog-close>Cancelar</button>
      <button class="btn btn-primary text-light mx-2" (click)="confirm()">Confirmar</button>
    </div>
</div>
